import { applyStaffTenantSwitch as applyStaffTenantSwitchCore } from "@l30/shared";

import { ApiError } from "../api/client.js";

import { clearSubjectNavigationSession } from "./subject-trail.js";

import type { QueryClient } from "@tanstack/react-query";

export function isSubjectUnavailableError(error: Error): boolean {
  if (!(error instanceof ApiError)) return false;
  if (error.status === 404 || error.status === 400) return true;
  return error.code === "NOT_FOUND" || error.code.endsWith("_NOT_FOUND");
}

/** React Query retry: do not repeat a handled missing-Subject response. */
export function retrySubjectQuery(failureCount: number, error: Error): boolean {
  if (isSubjectUnavailableError(error)) return false;
  return failureCount < 1;
}

export function subjectQueriesEnabledForOpenedTenant(
  openedTenant: string | null,
  currentTenant: string | null,
  subjectId: string,
): boolean {
  if (!subjectId) return false;
  return (openedTenant ?? "host-default") === (currentTenant ?? "host-default");
}

export async function applyStaffTenantSwitch(input: {
  nextSlug: string | null;
  navigate: (opts: { to: "/" }) => Promise<unknown> | unknown;
  queryClient: QueryClient;
}): Promise<void> {
  await applyStaffTenantSwitchCore({
    nextSlug: input.nextSlug,
    navigateHome: () => input.navigate({ to: "/" }),
    clearQueryCache: () => {
      clearSubjectNavigationSession();
      input.queryClient.clear();
    },
  });
}
